import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, Link, useLocation } from "react-router";
import Loader from "../../shared/loader/loader";
import {
  getCannedTestTypes,
  getRecommendedStandards,
  getCannedTest,
  getQuestionsCopyCannedTest,
  saveCannedTest,
  isQuestionValid,
  deleteCannedTestSection,
  getQuestions,
} from "../../../api/cannedTests.service";
import {
  AddIcon,
  CopyToClipboardIcon,
  ExclamationIcon,
} from "../../../assets/icons/index";
import constant from "../../../utils/constant";
import CannedTestQuestion from "../../../model/cannedTests/cannedTestQuestion";
import Select from "react-select";
import { connect } from "react-redux";
import Breadcrumb from "../../shared/common/breadcrumb";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import CannedTestCopyModal from "../cannedTests/cannedTestCopy";
import { Modal } from "../../shared/common/Modal";
import SelectList from "../../../model/shared/selectList";
import { IReactSelect } from "../../../model/interface/keyValuePair";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { toast } from "react-toastify";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import SectionCard from "./sectionCard";
import CannedTestSection from "../../../model/cannedTests/cannedTestSection";
import CannedTest from "../../../model/cannedTests/cannedTest";
import { getSubjectAPI } from "../../../api/subject.service";
import MultiSelect from "../../shared/common/multiSelect";
import { IQuestion } from "../../../model/interface/question";
import PreviewModal from "../questions/previewModal";
import CannedTestCopy from "../../../model/cannedTests/cannedTestCopy";
import Constant from "../../../utils/constant";
import CannedTestSortableItem from "./cannedTestSortableItem";
import { useNumericParam } from "../../../utils/useNumericParam";
import {
  buildDiagnosticTestName,
  isDiagnosticTestType,
} from "./cannedTestHelpers";

const CannedTestEdit: React.FC = (props: any) => {
  const location = useLocation();
  const initialState = {
    grade: 0,
    state: 0,
    cannedTestType: 0,
  };
  const defaultData: any = {
    cannedTestId: 0,
    states: [],
    cannedTestTypeId: 0,
    grades: [],
    subjectId: 0,
    sections: [],
    testQuestions: [],
    userId: props.profile?.userId,
    name: "",
    isApproved: false,
    requiresSubscription: false,
    resourcePassageId: undefined,
    displayOrder: undefined,
  };
  const newRow: CannedTestQuestion = {
    questionId: 0,
    recommendedStandardId: 0,
    orderNumber: 0,
    recommendedStandardName: "",
  };

  const [grade, setGrade] = useState<Array<SelectList>>([]);
  const [state, setState] = useState<Array<SelectList>>([]);
  const [subject, setSubject] = useState<Array<SelectList>>([]);
  const [cannedTestTypes, setCannedTestTypes] = useState<Array<SelectList>>([]);
  const [testQuestionIds, setTestQuestionIds] = useState<Array<SelectList>>([]);
  const [selectedTestInstructionQuestionColumn] = useState<
    Array<TestInstructionQuestionColumn>
  >([]);
  const [cannedTest, setCannedTest] = useState(defaultData);
  const [recommendedStandard, setRecommendedStandard] = useState<Array<any>>();
  const [filterInput, setFilterInput] = useState<any>(initialState);
  const [loading, setLoading] = useState<boolean>(false);
  const [isCopyStarted, setIsCopyStarted] = useState<boolean>(false);
  const navigate = useNavigate();
  const cannedtestId = useNumericParam("cannedtestId");
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isEditIndex, setIsEditIndex] = useState<number>(-1);
  const [isNew, setIsNew] = useState(true);
  type TestInstructionQuestionColumn = {
    index: number;
    options: [];
    questionIds: number[];
  };
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedRecommendedStandard, setSelectedRecommendedStandard] =
    useState<IReactSelect>();
  const [testEditMode, setTestEditMode] = useState<number>(
    Constant.CANNED_TEST_EDIT_MODE.PREMIUM_ASSESSMENT // Default to Premium Assessment
  );
  const [name, setName] = useState<string>("");
  const [isApproved, setIsApproved] = useState<boolean>(false);
  const [requiresSubscription, setRequiresSubscription] =
    useState<boolean>(false);
  const [resourcePassageId, setResourcePassageId] = useState<string>("");
  const [displayOrder, setDisplayOrder] = useState<string>("");
  const [isDeprecated, setIsDeprecated] = useState<boolean>(false);
  const [showSaveOrderFlag, setShowSaveOrderFlag] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [errorModalMessage, setErrorModalMessage] = useState<string>("");
  const [cannedTestSections, setCannedTestSections] = useState<
    Array<CannedTestSection>
  >([]);
  const [selectedStates, setSelectedStates] = useState<Array<any>>([]);
  const [selectedGrades, setSelectedGrades] = useState<Array<any>>([]);
  const [searchQuestion, setSearchQuestion] = useState<Array<any>>();
  const [selectedTestQuestion, setSelectedTestQuestion] =
    useState<IReactSelect>();
  const [open, setOpen] = useState<boolean>(false);
  const [previewId, setPreviewId] = useState<string>("");
  const [questionToPreview, setQuestionToPreview] = useState<
    IQuestion | undefined
  >();
  const [questionIdPreview, setQuestionIdPreview] = useState<number>();
  const [questionIndexPreview, setQuestionIndexPreview] = useState<number>();
  const [allQuestionList, setAllQuestionList] = useState<IQuestion[]>([]);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  // PLP-5999: Display Order only sorts the Premium Assessments tab, which lists Practice
  // Tests, so the field is hidden for any other type. Cast because the dropdown returns
  // its value as a string.
  const isPracticeTest =
    Number(cannedTest.cannedTestTypeId) ===
    Constant.CANNED_TEST_TYPE.PRACTICE_TEST;

  // PLP-6459: the Assessment Bank always shows a diagnostic as "<subject> - Diagnostic <type>"
  // and search matches the stored name, so a diagnostic's name is read-only and rebuilt on
  // every save. Labels come from the option lists because filterInput only holds them after a
  // dropdown change. Undefined while a label is missing, so the stored name is kept.
  const isDiagnostic = isDiagnosticTestType(cannedTest.cannedTestTypeId);
  const diagnosticName = isDiagnostic
    ? buildDiagnosticTestName(
        subject?.find((s) => s.value == cannedTest.subjectId)?.label ??
          filterInput.subjectName,
        cannedTestTypes?.find((t) => t.value == cannedTest.cannedTestTypeId)
          ?.label ?? filterInput.cannedTestTypeName
      )
    : undefined;
  const shownName = diagnosticName ?? name;

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    if (cannedTest.cannedTestId === 0) {
      if (cannedtestId) {
        bindCannedTestData(cannedtestId);
        searchQuestions();
      }
    }
  }, [cannedtestId]);

  useEffect(() => {
    if (location.state && !isCopyStarted) {
      const { cannedTestId, subjectId } = (location && location.state) || {};
      copyCannedTestData(cannedTestId, subjectId);
    }
  }, [location]);

  useEffect(() => {
    getCannedTestTypeData();
    getSubjectData();
    getRecommendedStandard();
    searchQuestions();
  }, [cannedTest.states, cannedTest.grades, cannedTest.subjectId]);

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Canned Test", url: constant.CANNEDTESTALL },
      {
        name: cannedtestId ? "Edit Canned Test" : "Add Canned Test",
        url: "",
      },
    ];

    if (cannedtestId) {
      items.push({ name: cannedtestId?.toString(), url: "" });
    }

    return items;
  };

  const getSubjectData = async (): Promise<SelectList[]> => {
    setLoading(true);
    const service = await import("../../../api/subject.service");
    const response = service.getSubjectByGrade(
      999 * 999,
      1,
      isNew ? filterInput.gradeId : cannedTest.grades
    );
    const data = (await response).data;
    let newSubjectData: SelectList[] = SelectList[0];
    if (data.data.length > 0) {
      newSubjectData = data.data.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.name}`,
        };
      });
    }
    setSubject(newSubjectData);
    setLoading(false);
    return newSubjectData;
  };

  const getCannedTestTypeData = async (): Promise<SelectList[]> => {
    const response = getCannedTestTypes();
    const data = (await response).data;
    let newTestTypeData: SelectList[] = SelectList[0];
    if (data.length > 0) {
      newTestTypeData = data.map((eachTestTypeData) => {
        return {
          value: eachTestTypeData.id || 0,
          label: `${eachTestTypeData.name}`,
        };
      });
    }
    setCannedTestTypes(newTestTypeData);
    return newTestTypeData;
  };

  const getRecommendedStandard = async () => {
    setLoading(true);
    if (cannedTest.subjectId > 0) {
      const response = getRecommendedStandards(
        cannedTest.states.map((ds) => ds.value),
        cannedTest.grades.map((ds) => ds.value),
        cannedTest.subjectId
      );
      let data = (await response).data;
      data = data.map((ds) => {
        return { label: ds.name, value: ds.id };
      });
      setRecommendedStandard(data);
    }
    setLoading(false);
  };

  const updateDropdownValues = (updateObj) => {
    if (updateObj.type == "State") {
      setCannedTest({
        ...cannedTest,
        states: updateObj.result,
      });
    } else if (updateObj.type == "Grade") {
      setCannedTest({
        ...cannedTest,
        grades: updateObj.result,
      });
    } else if (updateObj.type == "CannedTestType") {
      // PLP-5999: the field is about to be hidden, so drop the typed value instead of
      // letting it ride along in the save payload.
      const keepsDisplayOrder =
        Number(updateObj.value) === Constant.CANNED_TEST_TYPE.PRACTICE_TEST;
      if (!keepsDisplayOrder) setDisplayOrder("");
      setFilterInput({
        ...filterInput,
        cannedTestTypeId: updateObj.value || 0,
        cannedTestTypeName: updateObj.label || 0,
      });
      setCannedTest({
        ...cannedTest,
        cannedTestTypeId: updateObj.value,
        displayOrder: keepsDisplayOrder ? cannedTest.displayOrder : undefined,
      });
      setTestEditMode(getTestEditMode(parseInt(updateObj.value)));
    } else if (updateObj.type == "Subject") {
      setFilterInput({
        ...filterInput,
        stateId: 0,
        stateName: "",
        gradeId: 0,
        gradeName: "",
        subjectId: updateObj.value || 0,
        subjectName: updateObj.label || 0,
      });
      setCannedTest({
        ...cannedTest,
        subjectId: updateObj.value,
      });
      handleSubjectChange(updateObj.value);
    } else if (updateObj.type == "Domain") {
      setFilterInput({
        ...filterInput,
        domainId: updateObj.value || 0,
        domainName: updateObj.label || 0,
      });
    }
  };

  const handleSubjectChange = async (subjectId) => {
    if (!subjectId) return;
    const response = getSubjectAPI(subjectId);
    const subject = (await response).data;
    if (subject.states !== null && subject.states.length > 0) {
      subject.states.sort(
        (firstItem, secondItem) => firstItem.Id - secondItem.Id
      );
      const states = subject.states.map((eachGradeData) => {
        return {
          value: eachGradeData.id || 0,
          label: `${eachGradeData.name}`,
        };
      });
      setState(states);
    }

    if (subject.grades !== null && subject.grades.length > 0) {
      subject.grades.sort(
        (firstItem, secondItem) => firstItem.Id - secondItem.Id
      );
      const grades = subject.grades.map((eachGradeData) => {
        return {
          value: eachGradeData.id || 0,
          label: `${eachGradeData.name}`,
        };
      });
      setGrade(grades);
    }
  };

  const getTestEditMode = (cannedTestTypeId: number) => {
    switch (cannedTestTypeId) {
      case Constant.CANNED_TEST_TYPE.PRE_TEST:
      case Constant.CANNED_TEST_TYPE.POST_TEST:
        return Constant.CANNED_TEST_EDIT_MODE.PREMIUM_ASSESSMENT;
      default:
        return Constant.CANNED_TEST_EDIT_MODE.DEFAULT;
    }
  };

  const bindCannedTestData = async (cannedTestId) => {
    setLoading(true);
    const response: any = getCannedTest(cannedTestId);
    const cannedTestResponse: CannedTest = (await response).data;
    setLoading(false);
    setIsNew(false);
    if (cannedTestResponse) {
      const testEditMode = getTestEditMode(cannedTestResponse.cannedTestTypeId);
      setTestEditMode(testEditMode);
      // PLP-6459: keep the stored name for every type; a diagnostic shows its built name instead
      setName(cannedTestResponse.name ?? "");

      await handleSubjectChange(cannedTestResponse.subjectId);

      const states = cannedTestResponse?.states?.map((ds) => ({
        label: ds.name,
        value: ds.stateId,
      }));

      const grades = cannedTestResponse?.grades?.map((ds) => ({
        label: ds.name,
        value: ds.gradeId,
      }));

      const cannedTestTemp = {
        ...cannedTestResponse,
        states: states || [],
        grades: grades || [],
      };

      setCannedTest(cannedTestTemp);
      bindTestQuestionIds(cannedTestResponse.testQuestions);
      setCannedTestSections(cannedTestResponse.sections ?? []);
      setIsApproved(cannedTestResponse.isApproved ?? false);
      setRequiresSubscription(cannedTestResponse.requiresSubscription ?? false);
      setIsDeprecated(cannedTestResponse.isDeprecated ?? false);
      setResourcePassageId(
        cannedTestResponse.resourcePassageId?.toString() ?? ""
      );
      setDisplayOrder(cannedTestResponse.displayOrder?.toString() ?? "");
    } else {
      setCannedTest(defaultData);
    }
  };

  const copyCannedTestData = async (cannedTestId, subjectId) => {
    setLoading(true);
    const response: any = getCannedTest(cannedTestId);
    const cannedTestResponse: CannedTest = (await response).data;
    setLoading(false);
    setIsCopyStarted(true);
    if (cannedTestResponse) {
      setLoading(true);
      const copyResponse: any = getQuestionsCopyCannedTest(
        cannedTestId,
        subjectId
      );
      const copy: CannedTestCopy = (await copyResponse).data;
      setTestEditMode(getTestEditMode(cannedTestResponse.cannedTestTypeId));
      if (
        cannedTestResponse.cannedTestTypeId ===
        Constant.CANNED_TEST_TYPE.CANNED_TEST // To-do
      ) {
        setName(cannedTestResponse.name ?? "");
      }
      handleSubjectChange(subjectId);

      const states = copy.states.map((ds) => ({
        label: ds.name,
        value: ds.stateId,
      }));

      const grades = copy.grades.map((ds) => ({
        label: ds.name,
        value: ds.gradeId,
      }));

      cannedTestResponse.subjectId = subjectId;
      cannedTestResponse.cannedTestId = 0;
      cannedTestResponse.testQuestions = copy.questions;
      const isDiagnosticCopy = isDiagnosticTestType(
        cannedTestResponse.cannedTestTypeId
      );
      // PLP-6459: a copied diagnostic is named for its target subject, never the source's name
      if (isDiagnosticCopy) cannedTestResponse.name = "";
      const cannedTestTemp = {
        ...cannedTestResponse,
        states: states || [],
        grades: grades || [],
      };

      setIsNew(true);
      setCannedTest(cannedTestTemp);
      cannedTest.subjectId = cannedTestTemp.subjectId;
      setSelectedStates(states || []);
      setSelectedGrades(grades || []);
      setCannedTestSections(cannedTestResponse.sections ?? []);
      setResourcePassageId(
        cannedTestResponse.resourcePassageId?.toString() ?? ""
      );
      setDisplayOrder(cannedTestResponse.displayOrder?.toString() ?? "");
      const types: SelectList[] = await getCannedTestTypeData();
      console.log("types", types);
      const subjects: SelectList[] = await getSubjectData();
      console.log("subjects", subjects);
      const cannedTestTypeName = types.filter(
        (t) => t.value == cannedTestResponse.cannedTestTypeId
      )[0]?.label;
      const subjectName = subjects.filter((s) => s.value == subjectId)[0]
        ?.label;
      setFilterInput({
        ...filterInput,
        cannedTestTypeId: cannedTestResponse.cannedTestTypeId,
        cannedTestTypeName: cannedTestTypeName,
        subjectId: subjectId,
        subjectName: subjectName,
      });
      bindTestQuestionIds(cannedTestResponse.testQuestions);
      setIsApproved(false);
      setRequiresSubscription(false);
      setLoading(false);
    } else {
      setCannedTest(defaultData);
    }
  };

  const onEditClick = (testQuestion, index) => {
    setIsEdit(true);
    setIsEditIndex(index);
    setSelectedRecommendedStandard({
      label: recommendedStandard?.filter(
        (d) => d.value === testQuestion.recommendedStandardId
      )[0]?.label,
      value: recommendedStandard?.filter(
        (d) => d.value === testQuestion.recommendedStandardId
      )[0]?.value,
    });
    setSelectedTestQuestion({
      label: testQuestion.questionId,
      value: testQuestion.questionId,
    });
    setTimeout(() => {
      for (const key in testQuestion) {
        const element: any = document.getElementById(`${key}`);
        if (element) element.value = testQuestion[key];
      }
    });
  };

  const onEditSubmit = async (index) => {
    setLoading(true);
    const obj: any = {};

    obj["questionId"] = selectedTestQuestion?.value;
    const isOrderNumberRepeated = checkIsOrderNumberRepeated(
      cannedTest.testQuestions[index]["orderNumber"],
      cannedTest.testQuestions[index]
    );
    const IsQuestionIdRepeated = checkIsQuestionIdRepeated(
      obj["questionId"],
      cannedTest.testQuestions[index]
    );
    obj["recommendedStandardId"] = selectedRecommendedStandard?.value;
    obj["recommendedStandardName"] = recommendedStandard?.filter(
      (d) => d.value === selectedRecommendedStandard?.value
    )[0]?.label;

    let isValidQuestion: any = await isQuestionValid(
      cannedTest.states.map((ds) => ds.value) || 0,
      cannedTest.grades.map((ds) => ds.value) || 0,
      cannedTest.subjectId,
      obj["questionId"]
    );
    isValidQuestion = (await isValidQuestion).data;
    if (
      isValidQuestion === true &&
      isOrderNumberRepeated == false &&
      IsQuestionIdRepeated == false
    ) {
      cannedTest.testQuestions[index] = {
        ...cannedTest.testQuestions[index],
        ...obj,
      };
      setIsEdit(false);
      setIsEditIndex(-1);
      toast.success("Question added successfully");
      bindTestQuestionIds(cannedTest.testQuestions);
    } else {
      toast.warning(
        isValidQuestion == false
          ? "Question Id is invalid."
          : isOrderNumberRepeated == true
          ? "Order Number is repeated"
          : IsQuestionIdRepeated == true
          ? "Question Id is repeated"
          : ""
      );
    }
    setLoading(false);
  };

  const checkIsOrderNumberRepeated = (value, testQuestion) => {
    const isOrderNumberExists = cannedTest.testQuestions.filter(
      (q) => q?.orderNumber == value && q?.questionId != testQuestion.questionId
    )[0]?.questionId;
    if (isOrderNumberExists !== undefined) {
      return true;
    }
    return false;
  };

  const checkIsQuestionIdRepeated = (value, testQuestion) => {
    const isQuestionIdExists = cannedTest.testQuestions.filter(
      (q) => q.questionId == value && q.questionId != testQuestion.questionId
    )[0]?.questionId;
    if (isQuestionIdExists !== undefined) {
      return true;
    }
    return false;
  };

  const onCancelClick = (index) => {
    setIsEdit(false);
    setIsEditIndex(-1);
  };

  const handleInlineOnChange = (e: any) => {
    setSelectedRecommendedStandard(e);
  };
  const handleInlineTestQuestionOnChange = (e: any) => {
    setSelectedTestQuestion(e);
  };
  const onSaveClick = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    setIsSaving(true);
    setLoading(true);

    // Validate resource passage ID first
    if (!validateResourcePassageId(resourcePassageId)) {
      setErrorModalMessage(
        "Please enter a valid passage ID (must be a positive number) or leave the field empty."
      );
      setShowErrorModal(true);
      setLoading(false);
      setIsSaving(false);
      return;
    }

    // PLP-5999: Only Practice Tests expose the field, so nothing else can fail this check
    if (isPracticeTest && !validateDisplayOrder(displayOrder)) {
      setErrorModalMessage(
        "Please enter a valid display order (a number between 1 and 9999) or leave the field empty."
      );
      setShowErrorModal(true);
      setLoading(false);
      setIsSaving(false);
      return;
    }

    if (
      testEditMode === Constant.CANNED_TEST_EDIT_MODE.PREMIUM_ASSESSMENT &&
      cannedTest.testQuestions.length == 0
    ) {
      toast.warning("Please add test questions");
    } else if (
      testEditMode === Constant.CANNED_TEST_EDIT_MODE.DEFAULT &&
      cannedTestSections.length == 0
    ) {
      toast.warning("Please add sections");
    } else {
      if (
        testEditMode === Constant.CANNED_TEST_EDIT_MODE.DEFAULT &&
        cannedTestSections.length > 0
      ) {
        cannedTest.sections = cannedTestSections;
      }
      const questions: any = cannedTest.testQuestions.map((val) => ({
        questionId: val.questionId,
        recommendedStandardId: val.recommendedStandardId,
        orderNumber: val.orderNumber,
      }));
      cannedTest.testQuestions = questions;
      await saveCannedTest({
        ...cannedTest,
        ...(diagnosticName !== undefined && { name: diagnosticName }),
        states: cannedTest.states.map((ds) => ({
          stateId: ds.value,
          name: ds.label,
        })),
        grades: cannedTest.grades.map((ds) => ({
          gradeId: ds.value,
          name: ds.label,
        })),
      })
        .then((res) => {
          setLoading(false);
          toast.success("Test added successfully");
          const editRoute = constant.CANNEDTESTDETAIL.replace(
            ":cannedtestId",
            res.data
          );
          if (editRoute === location.pathname) history.go(0);
          else navigate(editRoute);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response && error.response.status === 400) {
            // Handle bad request - show error modal
            setErrorModalMessage(
              error.response.data ||
                "The passage ID you entered is not valid. Please check the passage ID and try again."
            );
            setShowErrorModal(true);
          } else {
            // Handle other errors with toast
            toast.error("Failed to save test. Please try again.");
          }
        });
    }
    setLoading(false);
    setIsSaving(false);
  };

  const isValidTestQuestion = (testQuestion) => {
    if (testQuestion == undefined) {
      return true;
    }
    if (testQuestion.questionId == 0) {
      toast.warning("Please select a valid question id");
      return false;
    } else if (testQuestion.recommendedStandardId == 0) {
      toast.warning("Please select a valid recommended standard");
      return false;
    }

    return true;
  };

  const onAddClick = () => {
    if (
      cannedTest?.states?.length > 0 &&
      cannedTest?.grades?.length > 0 &&
      cannedTest.subjectId > 0
    ) {
      if (
        isValidTestQuestion(
          cannedTest.testQuestions[cannedTest.testQuestions.length - 1]
        )
      ) {
        newRow.orderNumber =
          cannedTest.testQuestions[cannedTest.testQuestions.length - 1] !==
          undefined
            ? cannedTest.testQuestions[cannedTest.testQuestions.length - 1]
                .orderNumber + 1
            : 1;
        setSelectedTestQuestion({ label: "", value: 0 });
        cannedTest.testQuestions.push(newRow);
        setCannedTest(cannedTest);
        setIsEdit(true);
        setIsEditIndex(cannedTest.testQuestions.length - 1);
      }
    } else {
      toast.warning("Please select a State, Grade and Subject");
    }
  };

  const bindTestQuestionIds = (testQuestions) => {
    const selectedQuestionIds = [0];
    selectedTestInstructionQuestionColumn.map((eachColumn) => {
      eachColumn.questionIds.map((questionId) => {
        selectedQuestionIds.push(questionId);
      });
    });
    let newTestQuestionIdData = [];
    if (testQuestions.length > 0) {
      newTestQuestionIdData = testQuestions.map((eachTestQuestion) => {
        return {
          value: eachTestQuestion.questionId || 0,
          label: `${eachTestQuestion.questionId}`,
        };
      });
    }
    setTestQuestionIds(newTestQuestionIdData);
  };

  const onDeleteTestQuestionClick = (index) => {
    const testQuestions = cannedTest.testQuestions.filter(
      (q, i) => i !== index
    );

    setCannedTest({
      ...cannedTest,
      testQuestions: testQuestions,
    });
  };

  const onImportClick = () => {
    if (cannedtestId) {
      navigate(
        constant.CANNEDTESTDETAILIMPORT.replace(
          ":cannedtestId",
          cannedtestId.toString()
        )
      );
    } else {
      let obj = filterInput;
      if (name) {
        obj = { ...obj, name };
      }

      localStorage.setItem(
        "autoFill",
        JSON.stringify({
          autoFillData: { ...obj, isApproved },
        })
      );
      navigate(constant.CANNEDTESTIMPORT);
    }
  };

  const onCopyClick = () => {
    if (cannedTest.testQuestions.length === 0) {
      toast.warning("Question/s required to copy canned test");
      return;
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    navigate("/canned-tests");
  };

  const editQuestionHandler = (questionId) => {
    navigate(constant.MANAGEQUESTION.replace(":id", questionId.toString()), {
      state: { questionIdToEdit: questionId },
    });
  };

  const handleNameChange = (e) => {
    const name: string = e.target.value;
    setName(name);
    setCannedTest({
      ...cannedTest,
      name: name,
    });
  };

  const handleResourcePassageIdChange = (e) => {
    const value = e.target.value;
    setResourcePassageId(value);
    setCannedTest({
      ...cannedTest,
      resourcePassageId: value ? parseInt(value) : undefined,
    });
  };

  const validateResourcePassageId = (passageId: string): boolean => {
    if (!passageId) return true; // Optional field
    const numericValue = parseInt(passageId);
    return !isNaN(numericValue) && numericValue > 0;
  };

  const handleDisplayOrderChange = (e) => {
    const value = e.target.value;
    setDisplayOrder(value);
    setCannedTest({
      ...cannedTest,
      displayOrder: value ? parseInt(value) : undefined,
    });
  };

  // PLP-5999: optional field, capped at the 4 digits the ticket asks for.
  const validateDisplayOrder = (order: string): boolean => {
    if (!order) return true; // Optional field
    const numericValue = parseInt(order);
    return !isNaN(numericValue) && numericValue > 0 && numericValue <= 9999;
  };

  const openModal = (question) => {
    const questionId = question.questionId;
    setOpen(true);
    setPreviewId(question.englishQuestionReferenceId ?? "");
    setQuestionToPreview(question);
    setQuestionIdPreview(questionId);
  };

  const popUpClose = (value) => {
    setOpen(value);
    setPreviewId("");
    setQuestionIdPreview(undefined);
    setQuestionToPreview(undefined);
  };

  function handleIsApproved(e: any) {
    setIsApproved(e.target.checked);
    setCannedTest({
      ...cannedTest,
      isApproved: e.target.checked,
    });
  }

  function handleRequiresSubscription(e: any) {
    setRequiresSubscription(e.target.checked);
    setCannedTest({
      ...cannedTest,
      requiresSubscription: e.target.checked,
    });
  }

  function handleIsDeprecated(e: any) {
    setIsDeprecated(e.target.checked);
    setCannedTest({
      ...cannedTest,
      isDeprecated: e.target.checked,
    });
  }

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || cannedTest.testQuestions.length <= 1) return;

    if (active.id !== over.id) {
      const oldIndex = cannedTest.testQuestions.findIndex(
        (item, idx) => item.questionId.toString() + "-" + idx === active.id
      );
      const newIndex = cannedTest.testQuestions.findIndex(
        (item, idx) => item.questionId.toString() + "-" + idx === over.id
      );

      const tempTestQuestions = arrayMove(
        cannedTest.testQuestions,
        oldIndex,
        newIndex
      );
      const tempCannedTest = {
        ...cannedTest,
        testQuestions: tempTestQuestions,
      };
      setCannedTest(tempCannedTest);
      setShowSaveOrderFlag(true);
    }
  };

  const handleSaveOrder = () => {
    if (cannedTest.testQuestions.length == 0) {
      toast.warning("Please add test questions");
    } else {
      setLoading(true);
      const tempTestQuestions = cannedTest.testQuestions
        .filter((item, index) => {
          return item.questionId > 0;
        })
        .map((item, index) => {
          item.orderNumber = index + 1;
          return item;
        });

      const tempCannedTest = cannedTest;
      tempCannedTest.testQuestions = tempTestQuestions;
      saveCannedTest({
        ...tempCannedTest,
        ...(diagnosticName !== undefined && { name: diagnosticName }),
      })
        .then((res) => {
          setLoading(false);
          setShowSaveOrderFlag(false);
          setCannedTest(tempCannedTest);
          toast.success("Order saved successfully");
        })
        .catch((r) => {
          setLoading(false);
          setShowSaveOrderFlag(false);
        });
    }
  };

  const onAddSectionClick = () => {
    const newSection: CannedTestSection = {
      cannedTestSectionId: 0,
      cannedTestId: cannedTest.cannedTestId,
      subject: "",
      title: "",
      subtitle: "",
      sort: (cannedTestSections.length ?? 0) + 1,
      sectionGroups: [],
    };
    const sections = [...cannedTestSections];
    sections.push(newSection);
    setCannedTestSections(sections);
  };

  const saveSection = (section: any, index) => {
    cannedTestSections[index] = section;
    setCannedTestSections(cannedTestSections);
  };

  const onDeleteSectionClick = (index) => {
    const sections = cannedTestSections.filter((q, i) => i !== index);

    deleteCannedTestSection(cannedTestSections[index].cannedTestSectionId).then(
      (r) => {
        toast.success("Section deleted successfully");
        setCannedTestSections(sections);
      }
    );
  };

  const searchQuestions = async () => {
    const response = getQuestions(
      cannedTest.states.map((ds) => ds.value),
      cannedTest.grades.map((ds) => ds.value),
      cannedTest.subjectId
    );
    let data = (await response).data;
    setAllQuestionList(data);
    data = data.map((ds) => {
      return { label: ds.questionId, value: ds.questionId };
    });
    setSearchQuestion(data);
  };

  return (
    <AllowedTo
      perform={[Permissions.canned_test_create, Permissions.canned_test_modify]}
      no={() => <AccessDenied />}
    >
      {showModal && (
        <CannedTestCopyModal
          props={props}
          closeModal={closeModal}
          cannedTestId={cannedTest.cannedTestId}
        />
      )}

      {showErrorModal && (
        <Modal
          setShowModal={setShowErrorModal}
          title="Invalid Passage Resource"
          enableSubmitButton={false}
        >
          <div className="flex items-center gap-3">
            <ExclamationIcon
              className="h-6 w-6 text-yellow-500"
              aria-hidden="true"
            />
            <p className="text-sm text-gray-600">{errorModalMessage}</p>
          </div>
          <div className="mt-4 flex justify-end">
            <button
              type="button"
              className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:text-sm"
              onClick={() => setShowErrorModal(false)}
            >
              OK
            </button>
          </div>
        </Modal>
      )}

      {loading && <Loader />}

      <PreviewModal
        modal={openModal}
        show={open}
        changeValue={popUpClose}
        itemRef={previewId}
        questionIdPreview={questionIdPreview}
        questionIndexPreview={questionIndexPreview}
        setQuestionIndexPreview={setQuestionIndexPreview}
        questions={[]}
        setQuestionIdPreview={setQuestionIdPreview}
        setPreviewId={setPreviewId}
        questionToPreview={questionToPreview}
        setQuestionToPreview={setQuestionToPreview}
      ></PreviewModal>

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">Canned Tests</h3>
            </div>

            <Breadcrumb items={breadcrumbItems()} />

            <div>
              <div className="grid grid-cols-7 text-sm justify-between">
                <div className="col-span-2">
                  <form className="mr-2">
                    <div className="shadow py-6 border rounded-lg mt-4 px-4">
                      {/* PLP-6459: shown for every type; read-only for diagnostics */}
                      <div className="grid grid-cols-1 mb-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700">
                            Name
                          </label>
                        </div>
                        <div className="text-sm mt-1">
                          <input
                            id=""
                            name=""
                            value={shownName}
                            onChange={(e) => handleNameChange(e)}
                            readOnly={isDiagnostic}
                            type="text"
                            className={`block w-full ${
                              isDiagnostic ? "bg-gray-100" : ""
                            } border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm`}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5 mb-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700">
                            Canned Test Type
                          </label>
                        </div>
                        <div className="text-sm mt-1">
                          {isNew && (
                            <Select
                              value={{
                                label: filterInput.cannedTestTypeName,
                                value: filterInput.cannedTestTypeId,
                              }}
                              onChange={(result) =>
                                updateDropdownValues({
                                  ...result,
                                  type: "CannedTestType",
                                })
                              }
                              options={cannedTestTypes}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                            />
                          )}
                          {!isNew && (
                            <input
                              id="cannedTestType"
                              name="cannedTestType"
                              value={
                                cannedTestTypes.filter(
                                  (t) => t.value == cannedTest.cannedTestTypeId
                                )[0]?.label
                              }
                              type="text"
                              className="block w-full bg-gray-100 border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                              disabled
                            />
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700">
                            Subject
                          </label>
                        </div>
                        <div className="text-sm mt-1">
                          {isNew && (
                            <Select
                              value={{
                                label: filterInput.subjectName,
                                value: filterInput.subjectId,
                              }}
                              onChange={(result) =>
                                updateDropdownValues({
                                  ...result,
                                  type: "Subject",
                                })
                              }
                              options={subject}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                            />
                          )}
                          {!isNew && (
                            <input
                              id="subject"
                              name="subject"
                              value={
                                subject.filter(
                                  (s) => s.value == cannedTest.subjectId
                                )[0]?.label
                              }
                              type="text"
                              className="block w-full bg-gray-100 border border-gray-300 text-gray-700 rounded-md shadow-sm py-2 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                              disabled
                            />
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700">
                            State
                          </label>
                        </div>
                        <div className="text-sm mt-1">
                          {isNew && (
                            <MultiSelect
                              options={state}
                              selectedItems={selectedStates}
                              setSelectedItems={setSelectedStates}
                              onChange={(result) =>
                                updateDropdownValues({
                                  result,
                                  type: "State",
                                })
                              }
                            />
                          )}
                          {!isNew && (
                            <div className="disabled-input">
                              <MultiSelect
                                options={[]}
                                selectedItems={cannedTest.states}
                                setSelectedItems={setSelectedStates}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700">
                            Grade
                          </label>
                        </div>
                        <div className="text-sm mt-1">
                          {isNew && (
                            <MultiSelect
                              options={grade}
                              selectedItems={selectedGrades}
                              setSelectedItems={setSelectedGrades}
                              onChange={(result) =>
                                updateDropdownValues({
                                  result,
                                  type: "Grade",
                                })
                              }
                            />
                          )}
                          {!isNew && (
                            <div className="disabled-input">
                              <MultiSelect
                                options={[]}
                                selectedItems={cannedTest.grades}
                                setSelectedItems={setSelectedStates}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex items-center flex-row mt-5">
                        <div>
                          <input
                            id="isApproved"
                            type="checkbox"
                            checked={isApproved}
                            onChange={handleIsApproved}
                            className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                          />
                        </div>
                        <div className=" text-sm ">
                          <label className="font-medium text-gray-700">
                            Approved
                          </label>
                        </div>
                        {!isNew && (
                          <>
                            <div className="ml-6">
                              <input
                                id="isDeprecated"
                                type="checkbox"
                                checked={isDeprecated}
                                onChange={handleIsDeprecated}
                                className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                              />
                            </div>
                            <div className=" text-sm ">
                              <label className="font-medium text-gray-700">
                                Deprecated
                              </label>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="flex items-center flex-row mt-5">
                        <div>
                          <input
                            id="requiresSubscription"
                            type="checkbox"
                            checked={requiresSubscription}
                            onChange={handleRequiresSubscription}
                            className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                          />
                        </div>
                        <div className=" text-sm ">
                          <label className="font-medium text-gray-700">
                            Subscription Required
                          </label>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5 mb-5">
                        <div className="text-sm">
                          <label className="font-medium text-gray-700">
                            Resource (Passage ID)
                          </label>
                        </div>
                        <div className="text-sm mt-1">
                          <input
                            id="resourcePassageId"
                            name="resourcePassageId"
                            value={resourcePassageId}
                            onChange={(e) => handleResourcePassageIdChange(e)}
                            type="number"
                            min="1"
                            placeholder="Enter passage ID (optional)"
                            className={`block w-full border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
                              resourcePassageId &&
                              !validateResourcePassageId(resourcePassageId)
                                ? "border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500"
                                : "border-gray-300 text-gray-700 focus:ring-primary-color focus:border-primary-color"
                            }`}
                          />
                          {resourcePassageId &&
                            !validateResourcePassageId(resourcePassageId) && (
                              <p className="mt-1 text-xs text-red-600">
                                Please enter a valid passage ID (must be a
                                positive number)
                              </p>
                            )}
                          <p className="mt-1 text-xs text-gray-500">
                            Enter a passage ID to attach it as a resource to
                            both EN and ES versions of this test
                          </p>
                        </div>
                      </div>

                      {isPracticeTest && (
                        <div className="grid grid-cols-1 mt-5 mb-5">
                          <div className="text-sm">
                            <label className="font-medium text-gray-700">
                              Display Order
                            </label>
                          </div>
                          <div className="text-sm mt-1">
                            <input
                              id="displayOrder"
                              name="displayOrder"
                              value={displayOrder}
                              onChange={(e) => handleDisplayOrderChange(e)}
                              type="number"
                              min="1"
                              max="9999"
                              className={`block w-24 border rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm ${
                                displayOrder &&
                                !validateDisplayOrder(displayOrder)
                                  ? "border-red-300 text-red-900 focus:ring-red-500 focus:border-red-500"
                                  : "border-gray-300 text-gray-700 focus:ring-primary-color focus:border-primary-color"
                              }`}
                            />
                            {displayOrder &&
                              !validateDisplayOrder(displayOrder) && (
                                <p className="mt-1 text-xs text-red-600">
                                  Please enter a valid display order (a number
                                  between 1 and 9999)
                                </p>
                              )}
                            <p className="mt-1 text-xs text-gray-500">
                              Order this assessment is listed in within its
                              subject, on the Premium Assessments tab of the
                              Assignment Builder
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>

                <div className="px-2 mt-4 pb-4 col-span-5 shadow border rounded-lg">
                  <div
                    id="questions"
                    className={` ${
                      testEditMode !==
                      Constant.CANNED_TEST_EDIT_MODE.PREMIUM_ASSESSMENT
                        ? "hidden"
                        : ""
                    }`}
                  >
                    <h3 className="text-lg font-light text-gray-900">
                      Test Questions
                    </h3>
                    <form>
                      <div id="dataContainer" className="mt-4">
                        <div className="flex flex-col">
                          <div className="-my-2  sm:-mx-6 lg:-mx-8">
                            <div className="py-2 align-middle inline-block min-w-full px-10">
                              <div className="shadow border-b border-gray-200 sm:rounded-lg">
                                <DndContext
                                  sensors={sensors}
                                  collisionDetection={closestCenter}
                                  onDragEnd={handleDragEnd}
                                >
                                  <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-primary-color">
                                      <tr>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                                        >
                                          <span className="flex">Action</span>
                                        </th>
                                        <th
                                          scope="col"
                                          className="px-3 py-2 whitespace-nowrap  font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          <span className="flex">
                                            Sequence Number
                                          </span>
                                        </th>
                                        <th
                                          scope="col"
                                          className="inline-flex items-center whitespace-nowrap px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          <span className="flex">
                                            Question Id
                                          </span>
                                        </th>
                                        {testEditMode ===
                                          Constant.CANNED_TEST_EDIT_MODE
                                            .PREMIUM_ASSESSMENT && (
                                          <th
                                            scope="col"
                                            className="px-3 py-2  whitespace-nowrap font-light text-sm text-left text-white dark:text-white tracking-wider"
                                          >
                                            <span className="flex">
                                              Recommended Standards
                                            </span>
                                          </th>
                                        )}

                                        <th></th>

                                        <th
                                          scope="col"
                                          className="px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                        >
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    <SortableContext
                                      items={cannedTest.testQuestions.map(
                                        (item, idx) =>
                                          item.questionId.toString() + "-" + idx
                                      )}
                                      strategy={verticalListSortingStrategy}
                                    >
                                      <tbody>
                                        {cannedTest.testQuestions.map(
                                          (testQuestion, index) => (
                                            <CannedTestSortableItem
                                              key={
                                                testQuestion.questionId +
                                                "-" +
                                                index
                                              }
                                              testQuestion={testQuestion}
                                              index={index}
                                              isEdit={isEdit}
                                              isEditIndex={isEditIndex}
                                              onEditClick={onEditClick}
                                              onEditSubmit={onEditSubmit}
                                              onCancelClick={onCancelClick}
                                              onDeleteTestQuestionClick={
                                                onDeleteTestQuestionClick
                                              }
                                              editQuestionHandler={
                                                editQuestionHandler
                                              }
                                              selectedTestQuestion={
                                                selectedTestQuestion
                                              }
                                              handleInlineTestQuestionOnChange={
                                                handleInlineTestQuestionOnChange
                                              }
                                              testEditMode={testEditMode}
                                              Constant={Constant}
                                              recommendedStandard={
                                                recommendedStandard
                                              }
                                              selectedRecommendedStandard={
                                                selectedRecommendedStandard
                                              }
                                              handleInlineOnChange={
                                                handleInlineOnChange
                                              }
                                              searchQuestion={searchQuestion}
                                              selectedTestQuestionValue={
                                                selectedTestQuestion
                                              }
                                              selectedRecommendedStandardValue={
                                                selectedRecommendedStandard
                                              }
                                              isEditMode={isEdit}
                                              onPreview={openModal}
                                            />
                                          )
                                        )}
                                      </tbody>
                                    </SortableContext>
                                  </table>
                                </DndContext>
                              </div>
                              <div>
                                <div className="flex justify-end w-full">
                                  <button
                                    type="button"
                                    onClick={onAddClick}
                                    className="flex my-4 mx-3  items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                                  >
                                    <AddIcon className="w-3 h-3"></AddIcon>
                                    <span>Add Question</span>
                                  </button>

                                  {showSaveOrderFlag && (
                                    <button
                                      className="my-4 mx-3  items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                                      type="button"
                                      onClick={() => {
                                        handleSaveOrder();
                                      }}
                                    >
                                      Save Order
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div
                    id="sections"
                    className={` ${
                      testEditMode ===
                      Constant.CANNED_TEST_EDIT_MODE.PREMIUM_ASSESSMENT
                        ? "hidden"
                        : ""
                    }`}
                  >
                    <form>
                      <div id="dataContainer" className="mt-4">
                        <div className="flex flex-col">
                          <div className="flex flex-col px-4 py-2">
                            <div className="flex  justify-between">
                              <h3 className="text-lg font-light text-gray-900">
                                Sections
                              </h3>
                              <button
                                type="button"
                                onClick={onAddSectionClick}
                                className="flex mx-3  items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                              >
                                <AddIcon className="w-3 h-3"></AddIcon>
                                <span>Add Section</span>
                              </button>
                            </div>
                            {cannedTestSections.map((section, index) => {
                              return (
                                <Fragment key={index}>
                                  <SectionCard
                                    index={index}
                                    saveSection={saveSection}
                                    editQuestionHandler={editQuestionHandler}
                                    section={section}
                                    cannedTestTypeId={
                                      cannedTest.cannedTestTypeId
                                    }
                                    onDeleteSectionClick={onDeleteSectionClick}
                                  ></SectionCard>
                                </Fragment>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="pt-1">
                <form onSubmit={onSaveClick}>
                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    >
                      <span>Save</span>
                    </button>

                    {testEditMode ===
                      Constant.CANNED_TEST_EDIT_MODE.PREMIUM_ASSESSMENT &&
                      cannedtestId && (
                        <button
                          type="button"
                          onClick={onCopyClick}
                          className="ml-5 mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                        >
                          <CopyToClipboardIcon className="w-3 h-3 text-white dark:text-white fill-current"></CopyToClipboardIcon>
                          <span>Copy Test</span>
                        </button>
                      )}

                    <Link
                      type="button"
                      to={"/canned-tests"}
                      className="ml-5 mt-4 inline-flex items-center px-3 py-2 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    >
                      <span>Cancel</span>
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(CannedTestEdit);
